/**
 * User-facing label for the container-settings menu entry / dialog title.
 *
 * The label states what the panel actually CONTAINS, so it tells the user what
 * they will get (ui-design-principle-affordance-interactivity), and never uses
 * the word "container" — not an established term for our users (Margot,
 * 2026-09-28):
 *  - bundle    → "Bundle settings": the panel holds version + bundle_repository
 *                AND the dashboards manager, so it is genuinely settings-plural.
 *  - project   → "Configure dashboards": the panel holds ONLY the dashboards
 *                manager, so name it for its sole content (discoverability).
 *  - workspace → "Configure dashboards": dashboards-only too; this label also
 *                cleanly avoids colliding with the long-existing comprehensive
 *                "Workspace settings" (cog icon / left-menu node).
 *
 * The internal panel/route stays generically named, so if a project/workspace
 * ever gains a non-dashboard setting it becomes its own "…" menu entry next to
 * "Configure dashboards" — no re-rename needed. Decided with Margot 2026-10-05.
 *
 * The container-settings action is only registered for project / bundle /
 * workspace, so the generic fallback is defensive and should not be reached.
 */
export const containerSettingsLabel = (resourceType?: string): string => {
    switch (resourceType) {
        case "project":
            return "Configure dashboards";
        case "bundle":
            return "Bundle settings";
        case "workspace":
            return "Configure dashboards";
        default:
            return "Settings";
    }
};
